import React from 'react';
import './style.css';

class Aba extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        ano: new Date
    }
  }
  render(){
    return <div>
        <p>
        I am Red. I am { this.state.ano.getFullYear() - 2003} years old. I live in Brazil, Santa Catarina. And i like making maps, and videos. My favorite games are Half-life 2 and Crysis.
        </p>
    </div>
  };
}

export default Aba;